import React, { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import "./VideoModal.css";

const VideoModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasSeenVideo = sessionStorage.getItem("hasSeenVideo");
    if (!hasSeenVideo) {
      setIsOpen(true);
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    sessionStorage.setItem("hasSeenVideo", "true");
  };

  if (!isOpen) return null;

  return (
    <div className="video-modal-overlay" onClick={handleClose}>
      <div
        className="video-modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="video-close-btn" onClick={handleClose}>
          <IoMdClose />
        </button>

        <img
          src="/assets/video/silver_jubilee.gif"
          alt="Silver Jubilee"
          className="video-gif"
        />
      </div>
    </div>
  );
};

export default VideoModal;